import {
  AdminModel,
  DashboardContainerInterface,
  DatatableBuilderInterface,
  DatatableTypeInterface,
  PaginationRequest,
  PROVIDER_NAMES,
  textFiltrable,
} from '@ckmk/angular';
import { Injectable, inject } from '@angular/core';
import {
  faCopy,
  faEye,
  faPenToSquare,
  faTrash,
  faTrashArrowUp,
} from '@fortawesome/free-solid-svg-icons';
import { ServiceCategoryModel } from '@app/src/app/modules/service/classes/category/model/service.category.model';

@Injectable()
export class ServiceCategoryDatatableType implements DatatableTypeInterface {
  protected readonly container = inject<DashboardContainerInterface>(
    PROVIDER_NAMES.DASHBOARD_CONTAINER,
  );

  public constructor() {}

  public async configure(
    builder: DatatableBuilderInterface<AdminModel>,
  ): Promise<void> {
    const auth = this.container.authService.auth() as AdminModel;

    builder
      .setAuth(auth)
      .addIdentifyColumn()
      .addActiveColumn({
        editableOptions: {
          guard: {
            permissions: ['PERMISSION_UPDATE_SERVICE_CATEGORY'],
          },
        },
      })
      .add({
        type: 'file',
        name: 'cover',
        label: 'Cover',
        config: {
          editable: true,
          editableOptions: {
            guard: {
              permissions: ['PERMISSION_UPDATE_SERVICE_CATEGORY'],
            },
          },
        },
      })
      .add({
        type: 'translation',
        name: 'title',
        label: 'Title',
        config: {
          sortable: true,
          editable: true,
          fixed: true,
          editableOptions: {
            guard: {
              permissions: ['PERMISSION_UPDATE_SERVICE_CATEGORY'],
            },
          },
          filterable: textFiltrable({ translateAble: true }),
          inputs: {
            fieldConfig: {
              type: 'text',
            },
          },
        },
      })
      .add({
        type: 'text',
        name: 'slug',
        label: 'Slug',
        config: {
          sortable: true,
          editable: true,
          editableOptions: {
            guard: {
              permissions: ['PERMISSION_UPDATE_SERVICE_CATEGORY'],
            },
          },
          filterable: textFiltrable(),
        },
      })
      .addTimestampsColumns(auth.timezone)
      .addBlameColumns()
      .withPayload({
        filters: [],
        pagination: new PaginationRequest(),
        sorts: { createdAt: 'DESC' },
        includeCover: true,
        includeSoftDeleted: true,
      })
      .withActions([
        {
          name: 'show',
          label: 'Show',
          icon: faEye,
          guard: {
            permissions: ['PERMISSION_READ_SERVICE_CATEGORY'],
          },
          activeColor: 'var(--color-warning)',
          path: (sc: ServiceCategoryModel): any => [
            this.container.path('/services/categories/show'),
            sc.id,
          ],
          filter: (sc: ServiceCategoryModel) => !sc.deletedAt,
        },
        {
          name: 'update',
          label: 'Update',
          icon: faPenToSquare,
          guard: {
            permissions: ['PERMISSION_UPDATE_SERVICE_CATEGORY'],
          },
          activeColor: 'var(--color-success)',
          path: (sc: ServiceCategoryModel): any => [
            this.container.path('/services/categories/update'),
            sc.id,
          ],
          filter: (sc: ServiceCategoryModel) => !sc.deletedAt,
        },
        {
          name: 'copy',
          label: 'Copy',
          icon: faCopy,
          guard: {
            permissions: ['PERMISSION_COPY_SERVICE_CATEGORY'],
          },
          activeColor: 'var(--color-primary)',
          path: (sc: ServiceCategoryModel): any => [
            this.container.path('/services/categories/copy'),
            sc.id,
          ],
          filter: (sc: ServiceCategoryModel) => !sc.deletedAt,
        },
        {
          name: 'delete',
          label: 'Delete',
          icon: faTrash,
          guard: {
            permissions: ['PERMISSION_DELETE_SERVICE_CATEGORY'],
          },
          activeColor: 'var(--color-danger)',
          filter: (sc: ServiceCategoryModel) => !sc.deletedAt,
        },
        {
          name: 'restore',
          label: 'Restore',
          icon: faTrashArrowUp,
          guard: {
            roles: ['ROLE_DEV'],
          },
          activeColor: 'var(--color-danger)',
          filter: (sc: ServiceCategoryModel) => !!sc.deletedAt,
        },
      ])
      .saveToStorage();
  }
}
